export default function onSystemColorThemeChanged(callback: () => void) {
  const darkModePreference = matchMedia('(prefers-color-scheme: dark)');

  darkModePreference.addEventListener('change', callback);
}
